import { InjectionToken } from "@angular/core";
import { Pro } from "@shared/models";

export const PRO_LISTENER = new InjectionToken<IProListener>('cwt-pro-listener');

export interface IProListener {
    proInitialized(pro?: Pro): void;
}